import { UserStatus } from "@/api/SolarCloudApi";
import AuthLayout from "@/components/layouts/AuthLayout";
import LoadingSection from "@/components/LoadingSection";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/Card";
import { useUser } from "@/queries/user/useUser";
import { ArrowLeft } from "lucide-react";
import { Link, useNavigate } from "react-router";
import { useEffect } from "react";

export default function UserErrorPage() {
  const { data: user, isLoading, isFetching } = useUser();
  const navigate = useNavigate();
  const problemStatus = [
    UserStatus.CANCELLED,
    UserStatus.COMPROMISED,
    UserStatus.INACTIVE,
  ];

  useEffect(() => {
    if (!isLoading && !isFetching) {
      if (!user || (user.status && !problemStatus.includes(user.status))) {
        navigate("/login");
      }
    }
  }, [user, isLoading, isFetching, navigate, problemStatus]);

  if (isLoading || isFetching) {
    return <LoadingSection />;
  }
  return (
    <AuthLayout>
      <div className={"w-full max-w-lg mx-auto"}>
        <Card className="bg-brand-neutral-800 border-transparent shadow-none py-10">
          <CardHeader className="min-w-80">
            <CardTitle>Account Error: {user?.status}</CardTitle>
            <CardDescription>
              There was an issue with your account. Please contact support.
            </CardDescription>
          </CardHeader>
          <CardContent className="min-w-80">
            <Link to="/login" className="flex gap-x-2 text-white/80">
              <ArrowLeft /> Back to login
            </Link>
          </CardContent>
        </Card>
      </div>
    </AuthLayout>
  );
}
